import { CrawlerAddDetailModalView } from '../../components/CrawlerAddDetailModalView';
import { useAddDetailStore } from '../../hooks';

export const CrawlerAddDetailModal = () => {
  const addDetailStore = useAddDetailStore();

  return <CrawlerAddDetailModalView {...addDetailStore} />;
};
